import React from "react";
import { Button, Checkbox } from "antd";
import Utils from "@/utils";
import { ReactComponent as AudioIcon } from "@/assets/icons/audio-bold.svg";
import { ReactComponent as DeleteIcon } from "@/assets/icons/delete.svg";
import { ReactComponent as FileFailedIcon } from "@/assets/icons/file-failed.svg";
import { useTranslation } from "react-i18next";
import "@/assets/audioCompress.less";

const AudioCompressCompleteRender = ({
  submitStatus,
  audioCompressAfterList,
  selectedFileGuidList,
  handleFileSelect,
  handleDownload,
  deleteAudioCompressAfterItem,
  handleSubmitAgain,
}) => {
  const { t } = useTranslation(["audioCompress", "common"]);
  return (
    <div className="workplace-complete">
      <div className="point-con">
        <div className="workplace-complete-title">
          <span>
            {submitStatus === "success"
              ? t("Compressed Successfully")
              : submitStatus === "failed"
              ? t("Compression failed")
              : t("Compression is complete")}
          </span>
        </div>
      </div>
      <div className="point-con">
        {audioCompressAfterList.some(item => item.status === "success") ? (
          <div>
            <div className="success-list">
              <Checkbox.Group value={selectedFileGuidList} onChange={handleFileSelect} style={{ width: "100%" }}>
                {audioCompressAfterList
                  .filter(item => item.status === "success")
                  .map(item => (
                    <div className="item" key={item.guid}>
                      <div className="info">
                        <Checkbox value={item.guid}></Checkbox>
                        <AudioIcon />
                        <span>{Utils.omissionString(item.name, 5, 7)}</span>
                      </div>
                      <span>{(item.size / 1024 / 1024).toFixed(2)}MB</span>
                      <span>{item.quality}KBPS</span>
                      <DeleteIcon className="close" style={{ cursor: "pointer" }} onClick={() => deleteAudioCompressAfterItem(item.guid)} />
                    </div>
                  ))}
              </Checkbox.Group>
            </div>
            <div className="btn-groups">
              <Button type="primary" onClick={handleDownload}>
                {t("common:Download")}
              </Button>
              <Button
                type="primary"
                ghost
                onClick={() => {
                  window.open(window.location.href);
                }}
              >
                {t("Compress New")}
              </Button>
            </div>
          </div>
        ) : null}
        {audioCompressAfterList.some(item => item.status === "failed") ? (
          <div>
            <div className="failed-list">
              {audioCompressAfterList
                .filter(item => item.status === "failed")
                .map(item => (
                  <div className="item" key={item.guid}>
                    <div className="info">
                      <FileFailedIcon />
                      <span>{Utils.omissionString(item.name, 5, 7)}</span>
                    </div>
                    <span>{(item.size / 1024 / 1024).toFixed(2)}MB</span>
                    <span>{item.quality}KBPS</span>
                    <div className="del-tip">
                      <DeleteIcon className="close" style={{ cursor: "pointer" }} onClick={() => deleteAudioCompressAfterItem(item.guid)} />
                      <span>{t("common:Failed")}</span>
                    </div>
                  </div>
                ))}
            </div>
            {!audioCompressAfterList.some(item => item.status === "success") ? (
              <div className="btn-groups">
                <Button type="primary" onClick={handleSubmitAgain}>
                  {t("common:Try Again")}
                </Button>
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    window.open(window.location.href);
                  }}
                >
                  {t("Compress New")}
                </Button>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AudioCompressCompleteRender;
